<template>
	<div class="notificationsFormHeader puiformheader">
	</div>
</template>

<script>
import PuiFormHeaderMixin from '@Pui9Mixins/PuiFormHeaderMixin';

export default {
	name: 'notifications-form-header',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'notifications'
		};
	},
	computed: {
	}
}
</script>
